module.exports = __webpack_public_path__ + "media/images/icon__copy-to-clipboard-3ffa49b971c5662da666ee10a8280d92.png";